/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import SimpleCurrencyInput from '../../../common/SimpleCurrencyInput';
import Modal from '../../../common/Modal';
import OpenWithBillCounts from '../containers/OpenWithBillCountsContainer';

const OpenCashRegister = ({
  countBillsModalOff,
  countBillsModalIsOn,
  value,
  onChange,
  openCashRegister,
  canOpenPhysicalCashDrawer,
  openCashRegisterDrawer,
  defaultCashDrawerBalance,
}) => (
  <div>
    <Modal
      title={t('register:cash_register.open_register_modal_title')}
      close={countBillsModalOff}
      display-if={countBillsModalIsOn}
    >
      <OpenWithBillCounts />
    </Modal>
    <form onSubmit={openCashRegister}>
      <div className="c-input-group c-input-group--center u-mt--">
        <SimpleCurrencyInput
          className="c-input c-input--white c-input--prepend c-input-group__first"
          name="amount"
          type="tel"
          value={defaultCashDrawerBalance || value}
          onInputChange={onChange}
          addPrefix
        />
        <button className="c-btn c-btn--medium u-height-40">
          {t('register:cash_register.open_register_button')}
        </button>
        <button
          type="button"
          className="c-btn c-btn--medium c-btn--outline u-height-40 u-ml-"
          display-if={canOpenPhysicalCashDrawer}
          onClick={openCashRegisterDrawer}
        >
          {t('register:cash_register.open_physical_drawer_button')}
        </button>
      </div>
    </form>
  </div>
);
OpenCashRegister.propTypes = {
  countBillsModalOff: PropTypes.func.isRequired,
  countBillsModalIsOn: PropTypes.bool.isRequired,
  openCashRegister: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  openCashRegisterDrawer: PropTypes.func.isRequired,
  canOpenPhysicalCashDrawer: PropTypes.bool,
  defaultCashDrawerBalance: PropTypes.number.isRequired,
};
OpenCashRegister.defaultProps = {
  canOpenPhysicalCashDrawer: false,
};

export default OpenCashRegister;
